import showToast, { dismissToast } from '@/components/common/Toast';

export const TPM_CONTAINER_ID = 'tpm-navigator';

const tpmToast = (
  msg: React.ReactNode,
  overrides: Record<string, unknown> = {},
) => showToast(msg, {
  autoClose: 4000,
  containerId: TPM_CONTAINER_ID,
  position: 'bottom-left',
  ...overrides,
});

export const dismissTpmToast = (toastId: string) => dismissToast(toastId);

export default tpmToast;
